export default {
    init() {

    },
    finalize() {
        console.log('ciao')
    }, //fine finalized
};